export enum studentStatuses {
    confirmed = 'Confirmed',
    pendingRelease = 'Pending Release',
    ineligible = 'ATAR Ineligible',
    thirtyOrLess = "30 or less"
  };
